// extracted by mini-css-extract-plugin
export default {"root":"ProductConfigForm_root__hAs29"};